export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-9-sm-c43dc6aa892fe58f45ddffcc4822ce57.png";